module.exports = __webpack_public_path__ + "static/media/79.83ce25c9.jpg";